import * as React from 'react';
import { Container } from './styles.js';

const Card = React.forwardRef(({ children, defaultHoverBehavior, className, elevated, highlight, borderColor, testId, ...props }, ref) => (React.createElement(Container, { ...props, "data-testid": testId !== null && testId !== void 0 ? testId : 'card', ref: ref, className: className, "$defaultHover": defaultHoverBehavior, "$elevated": elevated, "$highlight": highlight, "$borderColor": borderColor }, children)));
Card.displayName = 'Card';

export { Card };
